/*
 * action types
 */

export const CHANGE_FOCUSED_STEP = "CHANGE_FOCUSED_STEP";
export const CHANGE_FOCUSED_ALTERNATIVE = "CHANGE_FOCUSED_ALTERNATIVE";
export const CHANGE_FOCUSED_POI = "CHANGE_FOCUSED_POI";
export const CHANGE_FOCUSED_PROVIDER_POI = "CHANGE_FOCUSED_PROVIDER_POI";
export const CHANGE_FOCUSED_PROVIDER_STORAGE =
  "CHANGE_FOCUSED_PROVIDER_STORAGE";
export const CHANGE_FOCUSED_CAR_RENT_OFFER = "CHANGE_FOCUSED_CAR_RENT_OFFER";
export const CHANGE_FOCUSED_PROVIDER_TOUR = "CHANGE_FOCUSED_PROVIDER_TOUR";
export const CHANGE_FOCUSED_PROVIDER_VIDEO = "CHANGE_FOCUSED_PROVIDER_VIDEO";
export const CHANGE_FOCUSED_PROVIDER_EVENT = "CHANGE_FOCUSED_PROVIDER_EVENT";
export const CLEAR_FOCUS = "CLEAR_FOCUS";
